<template>
  <q-btn
    :dark="isDarkModeGlobal"
    flat
    icon="edit"
    dense
    @click="layout = true"
  >
    <q-tooltip>Absorption attenuation coefficient calculation</q-tooltip>
  </q-btn>

  <q-dialog v-model="layout">
    <q-card
      :dark="isDarkModeGlobal"
      style="width: 800px; max-width: 80vw;"
    >
      <q-card-section>
        <div class="text-h6">
          Absorption attenuation coefficient [db/cm/MHz]
        </div>
      </q-card-section>

      <q-card-section class="q-pt-none q-pa-none">
        <p class="bold-text q-pa-md">
          <span class="normal-text">{{ absorptionAttenuationCoeffMessage }}</span>
        </p>
      </q-card-section>
      <q-card-section class="q-pa-sm q-ma-sm text-center row items-center justify-evenly">
        <h6>=</h6>

        <q-input
          v-model="absorptionAttenuationCoefficient"
          :dark="isDarkModeGlobal"
          filled
          type="number"
          step="0.01"
          label="Attenuation coefficient [db/cm/MHz]"
          style="min-width: 300px;"
        >
          <template #append>
            <q-btn
              fab-mini
              icon="book"
              color="primary"
              flat
              :dark="isDarkModeGlobal"
              @click="openLink(reference1)"
            >
              <q-tooltip>
                Show reference
              </q-tooltip>
            </q-btn>
          </template>
        </q-input>
        <h6>X</h6>
        <q-input
          v-model="absorptionFraction"
          :dark="isDarkModeGlobal"
          filled
          type="number"
          step="0.01"
          label="Absorption fraction [-]"
          style="min-width: 300px;"
        >
          <template #append>
            <q-btn
              fab-mini
              icon="book"
              color="primary"
              flat
              :dark="isDarkModeGlobal"
              @click="openLink(reference2)"
            >
              <q-tooltip>
                Show reference
              </q-tooltip>
            </q-btn>
          </template>
        </q-input>
      </q-card-section>
      <q-card-actions
        align="right"
        class="text-primary"
      >
        <q-btn
          flat
          label="OK"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
const layout = ref(false)
import {storeToRefs} from "pinia"
import { useCalculatorStore } from '../stores/calculator.store'
const calculatorStore = useCalculatorStore()
const {
  isDarkModeGlobal,
  absorptionFraction,
  absorptionAttenuationCoefficient
} = storeToRefs(calculatorStore)

const absorptionAttenuationCoeffMessage = `The attenuation coefficient reflects the decrease in ultrasound pressure as it
 travels through a medium, expressed in decibels per unit distance (in cm), per unit fundamental frequency (in MHz).
  The attenuation coefficient depends on the medium; for example, it is higher for bone compared to soft tissues,
   indicating that bone attenuates ultrasound more than soft tissues. The default is based on estimates reported in the
     literature (see reference) and is set to a relatively high value. Consequently, the absorption and temperature rise
       are relatively high. This default was chosen to represent a the worst-case scenario in terms of safety.
         Please note that a different default attenuation coefficient value is used for estimating derated Isppa.`

const reference1 = "https://doi.org/10.1121/1.386578"
const reference2 = "https://doi.org/10.1016/0301-5629(79)90086-3"
function openLink(link) {
  window.open(link, "_blank")
}

</script>
<style>

.bold-text {
  font-weight: bold;
}

.normal-text {
  font-weight: normal;
}
</style>